import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_ExpressionPrettyPrinter.scss';
import { _className, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { termPrinter } from './printers/termPrinter.js';
import { parseTermRelation } from './printers/termRelationParser.js';
import { deepClone, exists } from '@nu-art/ts-common';
import { ModuleFE_Value } from '../../../../_entity/value/index.js';
import { ModuleFE_Variable } from '../../../../_entity/variable/index.js';
import { ModuleFE_Expression } from '../../../../_entity/expression/index.js';
import { Renderer_StatusIndicator } from '../shared-components/status-indicator/Renderer_StatusIndicator.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { LogicType_And, LogicType_Or } from '@app/hcs-shared/expression';
import React from 'react';
export class Component_ExpressionPrettyPrinter extends TS_EditableItemComponentProto {
    static defaultProps = {
        valueModule: ModuleFE_Value,
        variablesModule: ModuleFE_Variable,
        expressionsModule: ModuleFE_Expression
    };
    resolvers = {
        resolveVariable: (variableId) => this.props.variablesModule.cache.unique(variableId),
        resolveValue: (valueId) => this.props.valueModule.cache.unique(valueId),
        resolveExpression: (expressionId) => this.props.expressionsModule.cache.unique(expressionId),
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.calculationResult = nextProps.calculationResult;
        state.parsedTermRelation = parseTermRelation(state.editable.item.expression ?? '');
        state.className = nextProps.className;
        return state;
    }
    shouldRenderExpressionInTitle = () => {
        return !this.state.parsedTermRelation.every(relation => relation.type !== 'unknown');
    };
    renderFlat = () => {
        if (this.state.parsedTermRelation.every(relation => relation.type !== 'unknown'))
            return '';
        return deepClone(this.state.editable.item).terms.map((term, index) => this.renderTerm(term, index, `T${index + 1}`, true));
    };
    renderTerm = (term, index, termTitle, renderTitle = false) => {
        const calculationResult = this.state.calculationResult?.[termTitle];
        return _jsxs(LL_V_L, { className: _className('pretty-print__term-list-item', renderTitle && 'flat'), children: [renderTitle && _jsxs(LL_H_C, { className: 'term-label-container', style: { gap: '5px' }, children: [(exists(this.state.calculationResult)) &&
                            _jsx(Renderer_StatusIndicator, { mode: 'calc', status: calculationResult?.['T'] }), _jsxs("div", { className: 'term-label', children: ["Term ", index + 1] })] }), termPrinter(term, this.resolvers, termTitle, this.state.calculationResult, this.props.tooltipContentResolver)] }, index);
    };
    renderWithRelation = () => {
        if (this.state.parsedTermRelation.some(relation => relation.type === 'unknown'))
            return '';
        return this.state.parsedTermRelation.map((parsedStep, _index) => {
            if (parsedStep.type === 'term') {
                const index = Number(parsedStep.value.split('T')[1]) - 1;
                return this.renderTerm(deepClone(this.state.editable.item).terms[index], _index, parsedStep.value);
            }
            if (parsedStep.type === 'operator') {
                switch (parsedStep.value) {
                    case LogicType_Or:
                        return _jsx("div", { className: 'pretty-print__sub-title', children: "Or:" }, _index);
                    case LogicType_And:
                        return _jsx("div", { className: 'pretty-print__sub-title', children: "And:" }, _index);
                }
            }
            if (parsedStep.type === 'sumGroup') {
                return _jsxs(React.Fragment, { children: [_jsx("div", { className: 'pretty-print__sub-title', children: "Sum of the following:" }), parsedStep.value.map((term, __index) => {
                            const index = Number(term.split('T')[1]) - 1;
                            return this.renderTerm(deepClone(this.state.editable.item).terms[index], __index, term);
                        })] }, _index);
            }
        });
    };
    renderBoolean = () => {
        const stringExpression = this.state.editable.item.expression?.trim() ?? '';
        if (this.state.parsedTermRelation.length !== 0 || (stringExpression.toLowerCase() !== 'true' && stringExpression.toLowerCase() !== 'false'))
            return;
        return _jsx(LL_V_L, { className: 'pretty-print__term-list-item', children: _jsx("div", { className: 'pretty-print__term-info', children: _jsx("ul", { className: 'pretty-print__atoms-list single-atom', children: _jsx("li", { className: 'pretty-print__atom-container content', children: stringExpression }) }) }) });
    };
    render() {
        const isFlat = this.state.parsedTermRelation.some(relation => relation.type === 'unknown');
        return _jsxs(LL_V_L, { className: _className(this.state.className, this.state.calculationResult && 'hide-markers'), id: 'expression-pretty-printer', children: [this.props.showHeader && _jsx("div", { className: 'pretty-print__title', children: this.state.editable.item.label }), this.shouldRenderExpressionInTitle() &&
                    _jsxs("div", { className: 'pretty-print__sub-title', children: ["Relation ", this.state.editable.item.expression, " of:"] }), _jsxs(LL_V_L, { className: _className('pretty-print__term-list', isFlat && 'flat'), children: [this.renderBoolean(), this.renderFlat(), this.renderWithRelation()] })] });
    }
}
//# sourceMappingURL=Component_ExpressionPrettyPrinter.js.map